import React from 'react';
import PageHero from '../components/layout/PageHero';
import BatteryThermalSimulator from '../components/tools/BatteryThermalSimulator';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import { Alert, AlertTitle, AlertDescription } from '../components/ui/alert';
import { Info } from 'lucide-react';

const BatteryThermalSimulatorPage = () => (
  <div className="min-h-screen" data-testid="battery-thermal-simulator-page">
    <PageHero
      eyebrow="Engineering Utilities"
      title="Battery Pack Thermal Simulator"
      description="Pack, cell-core and coolant temperatures over a drive cycle or a DC fast charge, the BMS power derating they cause, and how five cooling strategies compare on the same run."
      testId="battery-thermal-simulator-hero"
    />
    <section className="py-12 md:py-16">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 space-y-6">
        <Alert data-testid="thermal-assumptions-note">
          <Info className="h-4 w-4" />
          <AlertTitle className="font-chivo uppercase tracking-tight text-sm">Assumptions</AlertTitle>
          <AlertDescription>
            A lumped three-node model (cell core, pack, coolant) driven by the EV Powertrain
            Simulator's drive-cycle engine and the Charging Simulator's CC-CV solver. Heat is I²R
            from a measured DCIR map scaled to your pack, plus the sourced reversible (entropic)
            term for NMC and LFP. Two factors were calibrated against logged Nissan Leaf e+ data
            and checked against a Hyundai Kona log. It has no module-to-module gradients and no
            hot spots. It is an <strong>engineering approximation</strong> for comparing cooling
            concepts, not a replacement for a 3-D CFD/FEA pack model. See the User Guide's
            Validation and Assumptions &amp; Limitations sections.
          </AlertDescription>
        </Alert>
        <BatteryThermalSimulator />
        <ToolGuideCta guidePath="/simulation/battery-thermal/guide" toolName="Battery Pack Thermal Simulator" />
      </div>
    </section>
  </div>
);

export default BatteryThermalSimulatorPage;
